import React, { useState, useEffect } from "react";
import Page from "../../../components/general/page";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { getAccountingYearsList } from "../../../store/actions/accountingYears";
import Spinner from "../../../components/general/spinner";
import AccountingYearsList from "../../../components/accountingYear/accountingYearsList";
import ErrorNotification from "../../../components/documentDetails/errorNotification";
import { useNavigate } from "react-router-dom";

const AccountingYearsListView = ({pageRef}) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const main = useSelector(state => state.main);
  const company = useSelector(state => state.company);

  const [isLoadingList, setIsLoadingList] = useState(true);
  const [accountingYearsList, setAccountingYearsList] = useState([]);
  const [isErrorList, setIsErrorList] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAccountingYearsList()).then(res => {          
      if (res?.data?.periods?.length === 0){
        navigate("/new-accounting-year", {state: {isEmptyList: true}});
      } else {           
        // la key mi serve nella tabella antd
        setAccountingYearsList(res?.data?.periods.map(obj => ({ ...obj, key: obj.id })));
        setIsLoadingList(false);
      }
    }).catch((err) => {
      setIsErrorList(true);
      setIsLoadingList(false);
      setErrorMessage(err);
    });
  }, []);

  const selectedCompanyName = company?.companies?.find(el => el.id === main.clientIdSelected);

  return (
    <Page
      pageRef={pageRef}
      title={intl.formatMessage({ id: "accountingYear.title" })}
      subtitle={
        selectedCompanyName?.ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + main.companySelected
      }
      className={"contentStructure transparent"}
      subClassName="pageCss"   
    >
      {
        isLoadingList ?
          <Spinner /> :
          <AccountingYearsList                     
            accountingYearsList={accountingYearsList}
          />
      }    
      {
        isErrorList &&
        <ErrorNotification
          duration={2147483647}
          title={"Error"}
          message={errorMessage}
          show={isErrorList}
          type="error"
          hideToast={() => {setIsErrorList(false);}}
        />
      }
    </Page>
  );
};

export default AccountingYearsListView;